module.exports = __webpack_public_path__ + "static/media/zuleika-logo.08e80df8.png";